export default __webpack_public_path__ + "static/media/penguin AVENGERS.8e80eb94.png";